var map = {
	"./Afraid.png": 3023,
	"./Distain.png": 9000,
	"./Frown.png": 3294,
	"./Glad.png": 6187,
	"./Grimace.png": 4994,
	"./Grin.png": 5559,
	"./Meh.png": 9493,
	"./Stache.png": 8737,
	"./Stogie.png": 3171,
	"./Straw.png": 8222,
	"./Surprised.png": 7793,
	"./Tongue.png": 499,
	"./Toothy.png": 1555,
	"./Upset.png": 6793
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5621;